import { CANCELLATION_LIMIT_UNLIMITED_VALUE } from '../consts/app.const';

export const normalizePsAmountValue = (
  raw: string | number | undefined | null,
): string | undefined => {
  if (raw === undefined || raw === null) {
    return undefined;
  }

  const normalized = String(raw)
    .replace(/[$,\s]/g, '')
    .trim();

  if (!normalized) {
    return undefined;
  }

  if (normalized.toLowerCase() === 'unlimited') {
    return CANCELLATION_LIMIT_UNLIMITED_VALUE;
  }

  return normalized;
};

export default normalizePsAmountValue;
